








import { Vue, Component } from "vue-property-decorator";

@Component({
  components: {
    "exchange-rates-provider": () =>
      import(
        "@/components/app/admin/settings/currencies/exchangeRatesProvider.vue"
      ),
    "exchange-rates-listing": () =>
      import(
        "@/components/app/admin/settings/currencies/exchangeRatesListing.vue"
      )
  }
})
export default class ExchangeRatesListingModal extends Vue {}
